import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiGithub, FiTwitter, FiLinkedin, FiMail } from 'react-icons/fi';

export const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800/50 py-12 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} David | Solopreneur Solutions. Building tools for the indie web.
            </p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="text-slate-500 hover:text-indigo-400 transition-colors">
              <span className="sr-only">GitHub</span>
              <SafeIcon icon={FiGithub} className="h-5 w-5" />
            </a>
            <a href="#" className="text-slate-500 hover:text-indigo-400 transition-colors">
              <span className="sr-only">Twitter</span>
              <SafeIcon icon={FiTwitter} className="h-5 w-5" />
            </a>
            <a href="#" className="text-slate-500 hover:text-indigo-400 transition-colors">
              <span className="sr-only">LinkedIn</span>
              <SafeIcon icon={FiLinkedin} className="h-5 w-5" />
            </a>
            <a href="#" className="text-slate-500 hover:text-indigo-400 transition-colors">
              <span className="sr-only">Email</span>
              <SafeIcon icon={FiMail} className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};